import { Button } from '@lemon8/design';
import { useContext } from 'react';
import cls from 'classnames';
import { FormContext, FormItem } from '../../form';
import { ButtonSize, ButtonStatus } from '@lemon8/design/src/components/Button/button';

import './style.scss';

type Props = {
  isLoading: boolean;
  title: string;
  onClick: () => void;
};

export function FormButton(props: Props) {
  const { onClick, isLoading = false, title = 'Send' } = props;
  const { state } = useContext(FormContext);
  const isCanSubmit = state.values.reportFormSendBtn as boolean;

  return (
    <FormItem name="reportFormSendBtn" className="form-button">
      <Button
        className={cls('form-submit-button', {
          'not-submit': !isCanSubmit,
        })}
        title={title}
        status={isLoading ? ButtonStatus.loading : ButtonStatus.default}
        onClick={onClick}
        variant={'Primary'}
        size={ButtonSize.large}
      />
    </FormItem>
  );
}
